import styled, { css, keyframes } from "styled-components";
import IconOwned from "ui-components/Icon";
import CloseIcon from "./close.svg";
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
  opacity: 0.45;
`;
export const Wrapper = styled.div`
  box-sizing: border-box;
  display: inline-table;
  position: fixed;
  padding: 0.5rem;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;

  ${({
  isMobileViewportFit
}) => isMobileViewportFit && css`
      padding: 0;
      overflow-y: hidden;
    `}

  ${({
  isCentered
}) => isCentered && css`
      top: 0;
      display: flex;
      align-items: center;
    `}
`;
export const ModalContainer = styled.div`
  ${({
  isSizeLarge,
  isSizeRegular,
  isAnimated
}) => css`
      z-index: 100;
      background: #ffffff;
      box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);
      position: relative;
      margin: 1.75rem auto;
      border-radius: 3px;
      padding: 0;
      pointer-events: none;

      min-width: 300px;
      width: auto;

      ${isAnimated && css`
        animation-duration: 0.5s;
        animation-fill-mode: both;
        animation-name: ${fadeIn};
      `};
    `}
`;
export const Content = styled.div`
  pointer-events: auto;
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
`;
export const Title = styled.div`
  font-weight: 700;
  font-size: 1.2rem;
`;
export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 0.3rem;
  padding: 0.2rem 1rem 1rem;
  margin: 0 !important;
`;
export const BodyStyle = styled.div`
  padding: 0.5rem 1.5rem;
`;
export const ButtonClose = styled(IconOwned).attrs(() => ({
  name: CloseIcon.id
}))`
  margin: -1rem -1rem -1rem auto;
  fill: #aaaaaa;

  :hover {
    fill: #666666;
  }
`;